import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import * as dataFormat from "./UsersDataFormatters";
import actions from "../../../actions/usersListActions";
import axios from "axios";
import {
  GET_USER,
  API_TIMEOUT,
  GET_BANTUAN_JENIS,
  DELETE_BANTUAN_JENIS,
} from "../../../utils";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  Badge,
  UncontrolledTooltip,
  Input,
  Label,
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

import Widget from "../../Widget/Widget";

import s from "../Users.module.scss";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../../utils/func";
import { DELETE_BANTUAN_TAHUN } from "../../../utils";
import { set } from "lodash";

const { SearchBar } = Search;

const JenisBantuanListTable = (props) => {
  const { rows, dispatch, loading, idToDelete, modalOpen } = props;
  const [rowsTable, setRowsTable] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [rowsKu, setRowsKu] = useState([]);
  const [idHapus, setIdHapus] = useState();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState("2023");
  const [jumlahBantuan, setJumlahBantuan] = useState(0);
  const [jumlahDinas, setJumlahDinas] = useState(0);
  const [jumlahSumberDana, setJumlahSumberDana] = useState(0);
  const [jumlahBentuk, setJumlahBentuk] = useState(0);
  const [jumlahJenis, setJumlahJenis] = useState(0);

  const [tahun, setTahun] = useState("2023");
  const [selectedDinasFilter, setSelectedDinasFilter] = useState("All");
  const [rowsBase, setRowsBase] = useState([]);
  const [listDinas, setListDinas] = useState([]);

  const [modalDelete, setModalDelete] = useState(false);

  const dispatchKu = useDispatch();

  const cariBantuanTahun = (tahun) => {
    axios({
      method: "post",
      url: GET_BANTUAN_JENIS,
      timeout: API_TIMEOUT,
      data: {
        tahun: tahun,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL

          const data = response.data.data;

          let dataFilter = [];

          if (currentUser.peran == "admin") {
            dataFilter = data.filter((item) => {
              return item.dinas == currentUser.dinas;
            });
          } else {
            dataFilter = data;
          }

          const isSuperAdmin = currentUser.peran == "super admin";
          if (isSuperAdmin) {
            setRowsBase(dataFilter);
            const uniqueDinasList = [...new Set(dataFilter.map((item) => item.dinas))].filter(Boolean).sort();
            setListDinas(uniqueDinasList);
          }

          const displayData =
            isSuperAdmin && selectedDinasFilter !== "All"
              ? dataFilter.filter((item) => item.dinas === selectedDinasFilter)
              : dataFilter;

          setJumlahBantuan(displayData.length);
          const uniqueDinas = new Set(displayData.map((item) => item.dinas));
          const uniqueSumberDana = new Set(displayData.map((item) => item.sumberDana));
          const uniqueBentuk = new Set(displayData.map((item) => item.bentuk));
          const uniqueJenis = new Set(displayData.map((item) => item.jenis));
          setJumlahDinas(uniqueDinas.size);
          setJumlahSumberDana(uniqueSumberDana.size);
          setJumlahBentuk(uniqueBentuk.size);
          setJumlahJenis(uniqueJenis.size);
          setRowsKu(
            displayData.map((item, index) => ({
              ...item,
              nomor: index + 1,
            }))
          );

          //setFirstTable(response.data.data);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };

  useEffect(() => {
    if (!currentUser) {
      let currentUser = JSON.parse(localStorage.getItem("user"));
      //untuk kepentngan development

      setCurrentUser(currentUser);
    }
  }, []);

  useEffect(() => {
    const uid = currentUser ? currentUser.uid : null;
    if (uid) cariBantuanTahun("2023");
  }, [currentUser]);

  useEffect(() => {
    if (currentUser?.peran == "super admin" && rowsBase.length > 0) {
      const displayData =
        selectedDinasFilter === "All"
          ? rowsBase
          : rowsBase.filter((item) => item.dinas === selectedDinasFilter);
      setJumlahBantuan(displayData.length);
      const uniqueDinas = new Set(displayData.map((item) => item.dinas));
      const uniqueSumberDana = new Set(displayData.map((item) => item.sumberDana));
      const uniqueBentuk = new Set(displayData.map((item) => item.bentuk));
      const uniqueJenis = new Set(displayData.map((item) => item.jenis));
      setJumlahDinas(uniqueDinas.size);
      setJumlahSumberDana(uniqueSumberDana.size);
      setJumlahBentuk(uniqueBentuk.size);
      setJumlahJenis(uniqueJenis.size);
      setRowsKu(
        displayData.map((item, index) => ({
          ...item,
          nomor: index + 1,
        }))
      );
    }
  }, [selectedDinasFilter, rowsBase, currentUser]);

  const hitungUmur = (dob) => {
    const startDate = new Date(dob);
    const today = new Date();

    const yearDiff = today.getFullYear() - startDate.getFullYear();
    const monthDiff = today.getMonth() - startDate.getMonth();
    const totalMonthDiff = yearDiff * 12 + monthDiff;
    return totalMonthDiff;
  };

  const handleDelete = () => {
    axios({
      method: "delete",
      url: DELETE_BANTUAN_JENIS + idHapus,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          // ERROR
          return "error";
        } else {
          //BERHASIL
          alert("Data bantuan berhasil dihapus");
          const idToDelete = idHapus;
          const filteredArray = rowsKu
            .filter((obj) => obj.id !== idToDelete)
            .map((item, index) => ({ ...item, nomor: index + 1 }));
          setRowsKu(filteredArray);
          setRowsBase((prev) => prev.filter((obj) => obj.id !== idToDelete));
          setJumlahBantuan(filteredArray.length);
          const uniqueDinas = new Set(filteredArray.map((item) => item.dinas));
          const uniqueSumberDana = new Set(filteredArray.map((item) => item.sumberDana));
          const uniqueBentuk = new Set(filteredArray.map((item) => item.bentuk));
          const uniqueJenis = new Set(filteredArray.map((item) => item.jenis));
          setJumlahDinas(uniqueDinas.size);
          setJumlahSumberDana(uniqueSumberDana.size);
          setJumlahBentuk(uniqueBentuk.size);
          setJumlahJenis(uniqueJenis.size);
          setModalDelete(false);
        }
      })
      .catch((error) => {
        // ERROR
        alert(error);
      });
  };
  const openModal = (cell) => {
    const id = cell;

    setIdHapus(id);
    setModalDelete(true);
  };
  const closeModal = () => {
    setModalDelete(false);
  };
  const actionFormatter = (cell) => {
    return (
      <div className={`d-flex justify-content-between`}>
        <Button
          className={s.controlBtn}
          color="info"
          size="xs"
          onClick={() => props.dispatch(push(`/admin/bantuan/jenis/${cell}`))}
        >
          View
        </Button>
        <Button
          className={`${s.controlBtn} mx-2`}
          color="success"
          size="xs"
          onClick={() =>
            props.dispatch(push(`/admin/bantuan/jenis/${cell}/edit`))
          }
        >
          Edit
        </Button>
        <Button
          className={s.controlBtn}
          color="danger"
          size="xs"
          onClick={() => {
            openModal(cell);
          }}
        >
          Delete
        </Button>
      </div>
    );
  };

  useEffect(() => {
    dispatch(actions.doFetch({}));
  }, []);

  const columns = [
    {
      dataField: "nomor",
      text: "No.",
      sort: true,
      headerStyle: { width: "60px", minWidth: "60px", textAlign: "center" },
      style: { width: "60px", minWidth: "60px" },
    },
    {
      dataField: "dinas",
      sort: true,
      text: "Dinas",
      headerStyle: { width: "140px", minWidth: "140px" },
      style: { width: "140px", minWidth: "140px" },
    },
    {
      dataField: "bantuan",
      sort: true,
      text: "Bantuan",
      headerStyle: { width: "220px", minWidth: "120px" },
      style: { width: "220px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>
          {cell}
        </span>
      ),
    },
    {
      dataField: "sumberDana",
      sort: true,
      text: "Sumber Dana",
      headerStyle: { width: "100px", minWidth: "100px" },
      style: { width: "100px", minWidth: "100px" },
    },
    {
      dataField: "bentuk",
      sort: true,
      text: "Bentuk",
      headerStyle: { width: "90px", minWidth: "90px" },
      style: { width: "90px", minWidth: "90px" },
    },
    {
      dataField: "target",
      sort: true,
      text: "target",
      headerStyle: { width: "100px", minWidth: "100px" },
      style: { width: "100px", minWidth: "100px" },
    },
    {
      dataField: "jenis",
      sort: true,
      text: "Jenis",
      headerStyle: { width: "110px", minWidth: "110px" },
      style: { width: "110px", minWidth: "110px" },
    },
    {
      dataField: "id",
      formatter: actionFormatter,
      text: "Actions",
      headerStyle: { width: "180px", minWidth: "180px" },
      style: { width: "180px", minWidth: "180px" },
    },
  ];

  return (
    <div className={s.jenisBantuanMinimal}>
      <Widget className="widget-p-md">
        <Row className="mb-3">
          <Col xs={12}>
            <div className={`d-flex flex-wrap align-items-center ${s.summaryChipsWrap}`}>
              <span className={s.summaryChip} id="chip-dinas">
                <span className={s.summaryChipLabel}>Jumlah Dinas</span>
                <Badge color="primary" pill className={s.summaryChipValue}>
                  {jumlahDinas}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-dinas">
                Total dinas/instansi yang memiliki program bantuan
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-bantuan">
                <span className={s.summaryChipLabel}>Jumlah Bantuan</span>
                <Badge color="danger" pill className={s.summaryChipValue}>
                  {jumlahBantuan}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-bantuan">
                Total program/jenis bantuan yang terdaftar
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-sumber-dana">
                <span className={s.summaryChipLabel}>Jumlah Sumber Dana</span>
                <Badge color="info" pill className={s.summaryChipValue}>
                  {jumlahSumberDana}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-sumber-dana">
                Variasi sumber dana (APBD, APBN, dll) untuk program bantuan
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-bentuk">
                <span className={s.summaryChipLabel}>Jumlah Bentuk</span>
                <Badge color="warning" pill className={s.summaryChipValue}>
                  {jumlahBentuk}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-bentuk">
                Variasi bentuk bantuan (Uang, Barang, dll)
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-jenis">
                <span className={s.summaryChipLabel}>Jumlah Jenis</span>
                <Badge color="success" pill className={s.summaryChipValue}>
                  {jumlahJenis}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-jenis">
                Variasi jenis/kategori bantuan
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            className="pr-grid-col"
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {currentUser?.peran == "super admin" && (
              <div className="d-flex align-items-center mb-2 mb-md-0">
                <Label for="filter-dinas" className="mb-0 mr-2">
                  Filter Dinas:
                </Label>
                <Input
                  id="filter-dinas"
                  type="select"
                  value={selectedDinasFilter}
                  onChange={(e) => setSelectedDinasFilter(e.target.value)}
                  style={{ minWidth: "180px" }}
                >
                  <option value="All">All</option>
                  {listDinas.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </Input>
                <UncontrolledTooltip placement="top" target="filter-dinas">
                  Filter bantuan berdasarkan dinas/instansi. Pilih All untuk menampilkan semua.
                </UncontrolledTooltip>
              </div>
            )}
            <Button
              id="btn-tambah-bantuan"
              color="success"
              onClick={() => dispatchKu(push(`/admin/bantuan/jenis/new`))}
            >
              <i className="fa fa-plus mr-2" aria-hidden="true" />
              Tambah Bantuan
            </Button>
            <UncontrolledTooltip placement="left" target="btn-tambah-bantuan">
              Klik untuk menambah data jenis bantuan baru
            </UncontrolledTooltip>
          </Col>
        </Row>

        <ToolkitProvider columns={columns} data={rowsKu} keyField="id" search>
          {(props) => (
            <div className={s.jenisBantuanTableWrap}>
              <BootstrapTable
                bordered={false}
                classes="table-striped table-hover mt-4"
                pagination={paginationFactory()}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>
      <Modal size="sm" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>Konfirmasi hapus</ModalHeader>
        <ModalBody>
          apakah anda yakin akan menghapus data bantuan ini?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => handleDelete()}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(store) {
  return {
    loading: store.users.list.loading,
    rows: store.users.list.rows,
    modalOpen: store.users.list.modalOpen,
    idToDelete: store.users.list.idToDelete,
  };
}

export default connect(mapStateToProps)(JenisBantuanListTable);
